// extracted by mini-css-extract-plugin
module.exports = {"exploreMapSwitch":"styles-module__exploreMapSwitch___34Brt","mapView":"styles-module__mapView___p1WW2","listView":"styles-module__listView___3xUKH"};